import { render, staticRenderFns } from "./MemberMsg.vue?vue&type=template&id=15b4b096&scoped=true&"
import script from "./MemberMsg.vue?vue&type=script&lang=js&"
export * from "./MemberMsg.vue?vue&type=script&lang=js&"
import style0 from "./MemberMsg.vue?vue&type=style&index=0&id=15b4b096&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b4b096",
  null
  
)

export default component.exports